import service from "@/services/types/codigoReferencia";

export const namespaced = true;

export const state = () => ({
  list: [],
});

export const mutations = {
  LIST: (state, objs) => (state.list = objs),
};

export const actions = {
  list: ({ commit, state }, value) =>
    state.list?.length
      ? state.list
      : service.list(value).then((result) => {
          commit("LIST", result);

          return result;
        }),
};
